import { PageHeader, Tag, Tooltip, message } from "antd";
import { EyeOutlined, CheckCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ButtonItem, SegmentedItem, TableItemDinamico } from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import IconAbacus from "../../../Icons/IconAbacus";

moment.locale("es");

class OrdenesDeConteo extends Component {
    tableRef = null;
    state = {
        todosOrdenesDeConteo: [],
        loading: false,
        valor: 1,
    };
    consultarOrdenesDeConteo(params) {
        this.setState({ loading: true });
        axios
            .post(
                "ordenesDeConteo/selectTodasOrdenesDeConteo",
                { empresaId: this.props.empresaId, ...params },
                {
                    headers: this.props.headersToken,
                }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success !== 2) {
                    this.setState({ todosOrdenesDeConteo: [] });
                } else {
                    this.setState({
                        todosOrdenesDeConteo: res.data.data.map(valueOrdenDeConteo => {
                            return {
                                ...valueOrdenDeConteo,
                                numero: (valueOrdenDeConteo.serie ? (valueOrdenDeConteo.serie + " - ") : "") + (valueOrdenDeConteo.numero || ""),
                                responsableNombre: valueOrdenDeConteo.responsable ?
                                    (
                                        valueOrdenDeConteo.responsable.nombre + " " +
                                        valueOrdenDeConteo.responsable.apellidoPaterno + " " +
                                        valueOrdenDeConteo.responsable.apellidoMaterno
                                    ) : "",
                                supervisorNombre: valueOrdenDeConteo.supervisor ? (
                                    valueOrdenDeConteo.supervisor.nombre + " " +
                                    valueOrdenDeConteo.supervisor.apellidoPaterno + " " +
                                    valueOrdenDeConteo.supervisor.apellidoMaterno
                                ) : "",
                                supervisorId: valueOrdenDeConteo.supervisor?._id || valueOrdenDeConteo.supervisorId || null,
                                proyectoNombre: valueOrdenDeConteo.proyecto ? valueOrdenDeConteo.proyecto?.nombre : "",
                            }
                        }),
                        totalRecords: res.data.totalRecords || 0,
                    });
                }
            });
    }

    cancelarOrdenDeConteo(value) {
        this.setState({ loading: true });
        axios
            .post(
                "ordenesDeConteo/cancelarOrdenDeConteo",
                { ordenDeConteoId: value, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Orden de conteo cancelada correctamente");
                } else {
                    message.error("Sucedio un error y no se pudo cancelar");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    aprobarOrdenDeConteo(ordenDeConteoId) {
        this.setState({ loading: true });
        axios
            .post(
                "ordenesDeConteo/aprobarOrdenDeConteo",
                { ordenDeConteoId, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Orden de conteo aprobada correctamente");
                } else {
                    message.error("No se pudo aprobar la orden de conteo");
                }
                if (this.tableRef) {
                    this.tableRef.updateExternalFilters({ valor: this.state.valor });
                }
            });
    }

    contarOrdenDeConteo(ordenDeConteoId) {
        this.props.history.push(`/panel/contarOrdenDeConteo/${ordenDeConteoId}`);
    }

    verOrdenDeConteo(ordenDeConteoId) {
        this.props.history.push(`/panel/verOrdenDeConteo/${ordenDeConteoId}`);
    }

    render() {
        const columns = [
            {
                title: "Número",
                dataIndex: "numero",
                key: "numero",
                buscar: "numero",
                width: "6%",
            },
            {
                title: "Nombre",
                dataIndex: "nombre",
                key: "nombre",
                buscar: "nombre",
                width: "13%",
            },
            {
                title: "Descripción",
                dataIndex: "descripcion",
                key: "descripcion",
                buscar: "descripcion",
                width: "18%",
            },
            {
                title: "Modo conteo",
                dataIndex: "modoConteo",
                key: "modoConteo",
                width: "9%",
                render: (value) => {
                    switch (value) {
                        case 1: return "Ciego";
                        case 2: return "Semi-ciego";
                        case 3: return "Abierto";
                        default: return "—";
                    }
                }
            },
            {
                title: "Proyecto",
                dataIndex: "proyectoNombre",
                key: "proyectoNombre",
                width: "11%",
            },
            {
                title: "Supervisor",
                dataIndex: "supervisorNombre",
                key: "supervisorNombre",
                width: "11%",
            },
            {
                title: "Responsable",
                dataIndex: "responsableNombre",
                key: "responsableNombre",
                width: "11%",
            },
            {
                title: "Estado",
                dataIndex: "estado",
                key: "estado",
                width: "7%",
                render: (value) => {
                    if (value === 0) return <Tag color="red">Cancelada</Tag>;
                    if (value === 1) return <Tag color="default">Pendiente</Tag>;
                    if (value === 2) return <Tag color="blue">En proceso</Tag>;
                    if (value === 3) return <Tag color="green">Finalizada</Tag>;
                    return "—";
                },
            },
            {
                title: "Vigencia",
                dataIndex: "fechaVigencia",
                key: "fechaVigencia",
                width: "9%",
                render: (value) => value ? moment(value).format("DD/MM/YYYY") : "—",
            },
            {
                title: "Acción",
                dataIndex: "accion",
                key: "accion",
                width: "10%",
                render: (_, record) => {
                    const puedeContar =
                        record.responsableId === this.props.usuarioId &&
                        (record.estado === 1 || record.estado === 2);
                    const puedeAprobar =
                        record.requiereAprobacionSupervisor &&
                        record.estado === 3 &&
                        String(record.supervisorId) === String(this.props.usuarioId);
                    return (
                        <div className="acciones-container">
                            <Tooltip title="Ver orden">
                                <ButtonItem
                                    type="primary"
                                    size="small"
                                    icon={<EyeOutlined />}
                                    onClick={() => this.verOrdenDeConteo(record._id)}
                                />
                            </Tooltip>
                            {puedeContar && (
                                <Tooltip title="Contar">
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        lima
                                        icon={<IconAbacus marginRight={0} />}
                                        onClick={() => this.contarOrdenDeConteo(record._id)}
                                        style={{ marginLeft: 4, padding: "0px 0px" }}
                                    />
                                </Tooltip>
                            )}
                            {puedeAprobar && (
                                <Tooltip title="Aprobar">
                                    <ButtonItem
                                        type="default"
                                        size="small"
                                        verde
                                        icon={<CheckCircleOutlined />}
                                        onClick={() => this.aprobarOrdenDeConteo(record._id)}
                                        style={{ marginLeft: 4 }}
                                    />
                                </Tooltip>
                            )}
                        </div>
                    );
                }
            },
        ];

        return (
            <>
                <PageHeader
                    title="Órdenes de Conteo"
                    style={{
                        border: "1px solid rgb(235, 237, 240)",
                        backgroundColor: "white",
                        marginBottom: 10,
                    }}
                    extra={
                        <>
                            {window.innerWidth > 1000 &&
                                <>
                                    <SegmentedItem
                                        options={[{ label: 'Vigente', value: 1 }, { label: "Finalizado", value: 2 }, { label: 'Cancelado', value: 3 }, { label: 'Todos', value: 4 }]}
                                        onChange={(value) => {
                                            if (this.tableRef) {
                                                this.tableRef.updateExternalFilters({ valor: value, textoFiltro: this.state.textoFiltro });
                                            }
                                            this.setState({ valor: value });
                                        }}
                                        value={this.state.valor}
                                    />
                                </>
                            }
                        </>
                    }
                />
                <TableItemDinamico
                    ref={(ref) => this.tableRef = ref}
                    onRef={(ref) => this.tableRef = ref}
                    totalRecords={this.state.totalRecords}
                    loading={this.state.loading}
                    onFetchData={this.consultarOrdenesDeConteo.bind(this)}
                    anadirValorFiltro={this.state.valor}
                    size="small"
                    onlyMineFilter
                    dataSource={this.state.todosOrdenesDeConteo}
                    columns={columns}
                    scroll={{ x: "max-content" }}
                    semaforoVigencia
                    filterStorageKey={"ordenesDeConteo" + this.props.empresaId}
                    onRow={(record) => ({
                        onDoubleClick: () => {
                            this.verOrdenDeConteo(record._id);
                        },
                    })}
                    setValor={(valor) => this.setState({ valor })}
                    valorDefault={1}
                />
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
        usuarioId: state.user.usuarioId,
    };
};

export default connect(mapStateToProps)(OrdenesDeConteo);
